import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {TwitterButton, EmailButton} from 'react-social'
import {
  Link,
  LinkIcon
} from '../'
import Styles from './PlanScorecardTakeActionShare.css'

@CSSModules(Styles,{allowMultiple:true})
export default class PlanScorecardTakeActionShare extends Component {
  static propTypes = {
    description: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    petition: PropTypes.bool
  }
  constructor(props){
    super(props)
    this.state = {
      description: props.description,
      url: props.url,
      petition: props.petition || false
    }
  }
  render() {
    const { description, url, petition } = this.state

    let resultsOrPetitionA = 'these results'
    let resultsOrPetitionB = 'employer, coworkers, or social network'
    if (petition) {
      resultsOrPetitionA = 'this petition'
      resultsOrPetitionB = 'social network'
    }

    return (
      <div styleName='take-action-share'>
        <div styleName='take-action-label'>
          <h2>
            Share {resultsOrPetitionA}
          </h2>
          <p>
            Share {resultsOrPetitionA} with your {resultsOrPetitionB}.
          </p>
        </div>
        <div styleName='take-action-icons'>
          <div>
            <EmailButton
              title='Share via email'
              message={description}
              url={url}
              element='a'
            >
              <p>
                Email
              </p>
              <div>
                <LinkIcon nospace faclass='fa-envelope'/>
              </div>
            </EmailButton>
          </div>
          { /*
          <div>
            <Link
              to={'https://www.facebook.com/sharer/sharer.php?u='+url}
              title='Share via Facebook'
            >
              <p>
                Facebook
              </p>
              <div>
                <LinkIcon nospace faclass='fa-facebook-square'/>
              </div>
            </Link>
          </div>
          */ }
          { /*
          <div>
            <TwitterButton
              title='Share via Twitter'
              message={description}
              url={url}
              element='a'
            >
              <p>
                Twitter
              </p>
              <div>
                <LinkIcon nospace faclass='fa-twitter-square'/>
              </div>
            </TwitterButton>
          </div>
          */ }
        </div>
      </div>
    )
  }
}